// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-dash-edit-warning {
  width: 520px;
}
.dialog-dash-edit-warning__button + .dialog-dash-edit-warning__button {
  margin-left: 12px;
}
.dialog-dash-edit-warning__text-selected {
  font-weight: bold;
  white-space: pre-wrap;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogEditWarning/DialogEditWarning.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,iBAAA;AACR;AAEI;EACI,iBAAA;EACA,qBAAA;EACA,qBAAA;AAAR","sourcesContent":[".dialog-dash-edit-warning {\n  width: 520px;\n}\n.dialog-dash-edit-warning__button + .dialog-dash-edit-warning__button {\n  margin-left: 12px;\n}\n.dialog-dash-edit-warning__text-selected {\n  font-weight: bold;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
